import { render, staticRenderFns } from "./declaration-detail.vue?vue&type=template&id=56bf4e35"
import script from "./declaration-detail.vue?vue&type=script&lang=js"
export * from "./declaration-detail.vue?vue&type=script&lang=js"
import style0 from "./declaration-detail.vue?vue&type=style&index=0&id=56bf4e35&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports